export enum QUERY_KEY {
  GET_LOGGED_IN_USER_INFO = 'GET_LOGGED_IN_USER_INFO',
  GET_GROUP_USERS = 'GET_GROUP_USERS',

  GET_UNPINNING_REASONS = 'GET_UNPINNING_REASONS',

  // Venue Placement
  GET_LIST_VENUE_FILTER = 'GET_LIST_VENUE_FILTER',
  GET_LIST_VENUE_TYPE = 'GET_LIST_VENUE_TYPE',
  GET_VENUE_DETAIL = 'GET_VENUE_DETAIL',
  GET_LIST_PLACEMENT_TYPE = 'GET_LIST_PLACEMENT_TYPE',
  GET_LIST_DISTRIBUTION_CHANNEL = 'GET_LIST_DISTRIBUTION_CHANNEL',
  GET_LIST_UNASSIGNED_STATION = 'GET_LIST_UNASSIGNED_STATION',
  GET_PLACEMENT_LIST_IN_VENUE = 'GET_PLACEMENT_LIST_IN_VENUE',
  GET_VENUES_BY_GOOGLE_PLACE_IDS = 'GET_VENUES_BY_GOOGLE_PLACE_IDS',
}

export enum MUTATION_KEY {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_VALIDATE = 'FORGOT_PASSWORD_VALIDATE',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SUBMIT_PINNING_FORM = 'SUBMIT_PINNING_FORM',
}

export enum API_ENDPOINT_KEYS {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_VALIDATE = 'FORGOT_PASSWORD_VALIDATE',
  RESET_PASSWORD = 'RESET_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  LOGIN = 'LOGIN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  GET_PROFILE = 'GET_PROFILE',
  GET_PERMISSION_ROLLOUT_CONFIG = 'GET_PERMISSION_ROLLOUT_CONFIG',
}

export enum ROLLOUT_STATE {
  ON = 'ON',
  OFF = 'OFF',
  AUDIT = 'AUDIT',
}

export const SERVICE_RENTAL_ENDPOINTS: { [key in API_ENDPOINT_KEYS]: string } =
  {
    [API_ENDPOINT_KEYS.FORGOT_PASSWORD]: 'api/user/public/forgot-password',
    [API_ENDPOINT_KEYS.RESET_PASSWORD]: 'api/user/public/reset-password',
    [API_ENDPOINT_KEYS.FORGOT_PASSWORD_VALIDATE]:
      'api/user/public/forgot-password/validate',
    [API_ENDPOINT_KEYS.CHANGE_PASSWORD]: 'api/user/me/change-password',
    [API_ENDPOINT_KEYS.LOGIN]: 'login',
    [API_ENDPOINT_KEYS.REFRESH_TOKEN]: 'api/oauth/access-token',
    [API_ENDPOINT_KEYS.GET_PROFILE]: 'api/user/me',
    [API_ENDPOINT_KEYS.GET_PERMISSION_ROLLOUT_CONFIG]:
      'api/v1/permission-rollout-config',
  };

export const SERVICE_AUTH_ENDPOINTS: { [key in API_ENDPOINT_KEYS]: string } = {
  [API_ENDPOINT_KEYS.FORGOT_PASSWORD]: 'api/v1/user/public/forgot-password',
  [API_ENDPOINT_KEYS.RESET_PASSWORD]: 'api/v1/user/public/reset-password',
  [API_ENDPOINT_KEYS.FORGOT_PASSWORD_VALIDATE]:
    'api/v1/user/public/forgot-password/validate',
  [API_ENDPOINT_KEYS.CHANGE_PASSWORD]: 'api/v1/user/me/change-password',
  [API_ENDPOINT_KEYS.LOGIN]: 'api/v1/auth/login',
  [API_ENDPOINT_KEYS.REFRESH_TOKEN]: 'api/oauth2/token',
  [API_ENDPOINT_KEYS.GET_PROFILE]: 'api/v1/user/me',
  [API_ENDPOINT_KEYS.GET_PERMISSION_ROLLOUT_CONFIG]:
    'api/v1/permission-rollout-config',
};

export enum FEATURE_FLAGS {
  WEB_DASHBOARD_RESET_PASSWORD = 'WEB_DASHBOARD_RESET_PASSWORD',
  ENABLE_LISTING_PLACEMENT_TYPE_INSIDE_VENUE_TYPE = 'ENABLE_LISTING_PLACEMENT_TYPE_INSIDE_VENUE_TYPE',
  // ENG-7007 - Integrate Google Place API into Venue Creation Flow
  GOOGLE_PLACE_API_IN_VENUE_CREATION = 'GOOGLE_PLACE_API_IN_VENUE_CREATION',
  ENABLE_WEB_PINNING_SWAP_STATION = 'ENABLE_WEB_PINNING_SWAP_STATION',
  WEB_PINNING_RELOCATE_STATION = 'WEB_PINNING_RELOCATE_STATION',
}

export enum USER_ROLE {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  PARTNER = 'PARTNER',
  SALESPERSON = 'SALESPERSON',
  DISTRIBUTOR = 'DISTRIBUTOR',
  LIMITED_DISTRIBUTOR = 'LIMITED_DISTRIBUTOR',
  ANONYMOUS = 'ANONYMOUS',
  USER = 'USER',
  MANUFACTURER = 'MANUFACTURER',
}

export enum GROUP_TYPE {
  ADMIN = 'ADMIN',
  DISTRIBUTOR = 'DISTRIBUTOR',
}

export enum STATION_TYPE {
  SLOT_5 = '5 Slots Box',
  SLOT_10 = '10 Slots Box',
  SLOT_15 = '15 Slots Box',
  SLOT_25 = '25 Slots Box',
  SLOT_45 = '45 Slots Box',
  SLOT_100 = '100 Slots Box',
  BOX_5 = 'BOX_5',
  BOX_10 = 'BOX_10',
  BOX_15 = 'BOX_15',
  BOX_25 = 'BOX_25',
  BOX_45 = 'BOX_45',
  BOX_100 = 'BOX_100',
}

export enum STATION_SLOT {
  SLOT_5 = 5,
  SLOT_10 = 10,
  SLOT_15 = 15,
  SLOT_25 = 25,
  SLOT_45 = 45,
  SLOT_100 = 100,
}

export enum FORMAT_STATION_SLOT {
  SLOT_5 = 'F5',
  SLOT_10 = 'F10',
  SLOT_15 = 'F15',
  SLOT_25 = 'F25',
  SLOT_45 = 'F45',
  SLOT_100 = 'F100',
}

export enum BROWSER {
  SAFARI = 'Safari',
  CHROME = 'Chrome',
  OTHER = 'Other',
}

export enum DEVICE_TYPE {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  COMPUTER = 'COMPUTER',
}

export const DEFAULT_HELP_LINK =
  'https://www.google.com/search?q=how+to+turn+on+camera+permissions+for+browser';

export const CAMERA_PERMISSION_HELP_LINK: Record<
  BROWSER,
  Record<DEVICE_TYPE, string>
> = {
  [BROWSER.SAFARI]: {
    [DEVICE_TYPE.IOS]:
      'https://support.apple.com/en-mt/guide/iphone/iphb01fc3c85/ios',
    [DEVICE_TYPE.ANDROID]: DEFAULT_HELP_LINK,
    [DEVICE_TYPE.COMPUTER]:
      'https://support.apple.com/en-vn/guide/mac-help/mchlf6d108da/mac',
  },
  [BROWSER.CHROME]: {
    [DEVICE_TYPE.IOS]:
      'https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DiOS',
    [DEVICE_TYPE.ANDROID]:
      'https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DAndroid',
    [DEVICE_TYPE.COMPUTER]:
      'https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop',
  },
  [BROWSER.OTHER]: {
    [DEVICE_TYPE.IOS]: DEFAULT_HELP_LINK,
    [DEVICE_TYPE.ANDROID]: DEFAULT_HELP_LINK,
    [DEVICE_TYPE.COMPUTER]: DEFAULT_HELP_LINK,
  },
};
